import { render, staticRenderFns } from "./SericeStatusCard.vue?vue&type=template&id=74bd314f&scoped=true"
import script from "./SericeStatusCard.vue?vue&type=script&lang=js"
export * from "./SericeStatusCard.vue?vue&type=script&lang=js"
import style0 from "./SericeStatusCard.vue?vue&type=style&index=0&id=74bd314f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd314f",
  null
  
)

export default component.exports